/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";

import {
  convertToSnakeCase,
  empty,
  findGrade,
  isArray,
  isString,
  isUndefined,
  prepareResponseData,
  reIndex,
  validPayload,
} from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { capitalize, isObject } from "lodash";

// css
import "../students/Students.css";
import "./Assessment.css";

// api
import studentApi from "../../api/Student";
import classApi from "../../api/Classes";
import assessmentApi from "../../api/Assessment";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { Toast } from "primereact/toast";
import StudentsTable from "../../components/tables/primeTable/students/StudentsTable";
import { Form, Formik } from "formik";
import InputField from "../../components/form/InputField";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import * as Yup from "yup";
import FullPageLoader from "../../components/loader/FullPageLoader";
import { FaExclamationTriangle } from "react-icons/fa";
import { Button } from "primereact/button";
import TableLoading from "../../components/skeleton/TableLoading";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import colors from "../../config/colors";
import SelectField from "../../components/form/SelectField";
import InputFieldChange from "../../components/form/InputFieldChange";

const validationSchema = Yup.object().shape({
  ca1: Yup.string().max(2).optional(),
  ca2: Yup.string().max(2).optional(),
  exam: Yup.string().max(2).optional(),
});

const validationCommentSchema = Yup.object().shape({
  comment: Yup.string().required("This field is required"),
});

const RecordAssessment = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const paramState = !empty(location.state) ? location.state : {};
  const classId = paramState?.classId || "";
  const sessionId = user?.schoolData?.currentSessionId || "";
  const termId = user?.schoolData?.currentTermId || "";
  //ref
  const toastTR = useRef(null);
  const stepperRef = useRef(null);

  // states
  const [studentData, setStudentData] = useState([]);
  const [classData, setClassData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [search, setSearch] = useState("");
  const [studentAssessment, setStudentAssessment] = useState([]);
  const [reIndexedSubjects, setReIndexedSubjects] = useState({});
  const [isStudentDialog, setIsStudentDialog] = useState(false);
  const [openMultiAssessmentModal, setOpenMultiAssessmentModal] =
    useState(false);
  const [activeDetails, setActiveDetails] = useState({});
  const [studentReportComment, setStudentReportComment] = useState("");
  const [remarks, setRemarks] = useState([]);
  const [classCategoryId, setClassCategoryId] = useState([]);
  const [defaultCategoryId, setDefaultCategoryId] = useState([]);
  const [scoreGrades, setScoreGrades] = useState([]);
  const [hasPaid, setHasPaid] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [activationModalOpen, setActivationModalOpen] = useState(false);
  const [affectiveDomainData, setAffectiveDomainData] = useState([]);
  const [ratingIndicesData, setRatingIndicesData] = useState([]);
  const [psychomotor, setPsychomotor] = useState([]);
  const [studentPsychomotor, setStudentPsychomotor] = useState({});
  const [studentAffectiveDomain, setStudentAffectiveDomain] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState({});
  const [selectedStudent, setSelectedStudent] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [updatedAssessment, setUpdatedAssessment] = useState([]);
  const [initialValues, setInitialValues] = useState({
    ca1: 0,
    ca2: 0,
    exam: 0,
  });
  const [multiInitialValues, setMultiInitialValues] = useState({
    recordedAssessments:
      subjects?.map((subject) => ({
        _id: subject._id,
        ca1: "",
        ca2: "",
        exam: "",
      })) || [],
  });
  const [selectedStudentTotal, setSelectedStudentTotal] = useState(0);
  const [currentTermTitle, setCurrentTermTitle] = useState("");
  const [currentSessionTitle, setCurrentSessionTitle] = useState("");
  const [assessmentMaxScores, setAssessmentMaxScores] = useState("");

  const [ca1_max, setCa1Max] = useState(20);
  const [ca2_max, setCa2Max] = useState(20);
  const [exam_max, setExamMax] = useState(60);

  const validationMultiSchema = useMemo(() => {
    return Yup.object().shape({
      recordedAssessments: Yup.array().of(
        Yup.object().shape({
          ca1: Yup.number()
            .typeError("CA1 must be a number")
            .min(0, "Minimum is 0")
            .max(ca1_max, `CA1 cannot exceed ${ca1_max} marks`),
          ca2: Yup.number()
            .typeError("CA2 must be a number")
            .min(0, "Minimum is 0")
            .max(ca2_max, `CA2 cannot exceed ${ca2_max} marks`),
          exam: Yup.number()
            .typeError("Exam must be a number")
            .min(0, "Minimum is 0")
            .max(exam_max, `Exam cannot exceed ${exam_max} marks`),
        })
      ),
    });
  }, [ca1_max, ca2_max, exam_max]);

  useEffect(() => {}, [subjectId]);

  useEffect(() => {
    setCa1Max(assessmentMaxScores?.ca1_max || 20);
    setCa2Max(assessmentMaxScores?.ca2_max || 20);
    setExamMax(assessmentMaxScores?.exam_max || 60);
    setCurrentTermTitle(user?.schoolData?.currentTermTitle || "");
    setCurrentSessionTitle(user?.schoolData?.currentSessionTitle || "");
  }, [assessmentMaxScores, user]);

  useEffect(() => {
    // fetch student
    try {
      if (!empty(paramState?.classId)) {
        setAssessmentMaxScores(user?.assessmentMaxScores || "");
        getStudents();
        // getSubjectDetails();
        getClassDetails();
        getSubjectsInClass();
        getAffectiveDomains();
        getPsychomotor();
        getRatingIndices();
        getSubjects();
      } else {
        navigate("/404");
      }
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load student. Please try again later."
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [first, rows, search, classId]);

  useEffect(() => {
    assessmentData(selectedStudent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectId, selectedStudent]);

  /**
   * Open Assessment Modal
   * @param {*} data
   * @param {*} openModal
   */
  const openAssessmentModal = (data, openModal = true) => {
    setActiveDetails(data);
    const hasPaid =
      !empty(data) && !empty(data.paid) && data.paid === "Yes" ? true : false;
    setSelectedStudent(data);
    setHasPaid(hasPaid);
    if (openModal) {
      setIsStudentDialog(true);
    }
  };

  /**
   * Open Multiple Assessment Modal
   * @param {*} data
   * @param {*} openModal
   */
  const openMultipleAssessmentModal = (data) => {
    setActiveDetails(data);

    const _getStudentAssessment = getStudentAssessment(data);
    const currentStudentAssessmentData =
      _getStudentAssessment?.currentStudentAssessmentData || [];

    setStudentAssessment(currentStudentAssessmentData);

    const reIndexAssessment = Array.isArray(currentStudentAssessmentData)
      ? reIndex(currentStudentAssessmentData, "subjectId")
      : {};

    const _updatedAssessment = [];
    const recordedAssessments = [];

    if (Array.isArray(subjects)) {
      subjects.forEach((subject) => {
        const subjectId = subject?._id || "";
        const subjectTitle = subject?.title || "";
        const assessment = reIndexAssessment[subjectId];

        const ca1 = assessment?.ca1 || "";
        const ca2 = assessment?.ca2 || "";
        const exam = assessment?.exam || "";

        // For internal tracking
        _updatedAssessment.push({
          subjectId,
          subjectTitle,
          ca1,
          ca2,
          exam,
        });

        // For Formik form state
        recordedAssessments.push({
          _id: subjectId,
          ca1,
          ca2,
          exam,
        });
      });

      setUpdatedAssessment(_updatedAssessment);
      setMultiInitialValues({
        recordedAssessments,
      });
    }

    setOpenMultiAssessmentModal(true);
  };

  const getSubjects = async () => {
    try {
      const response = await classApi.getSubjectsInClass(
        classId,
        1000
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.response) ||
        !response_data.response
      ) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "There are no subjects registered for this class."
            : "There are no subjects registered for this class."
        );
      }

      const subjectData = isArray(response_data?.response)
        ? response_data.response
        : [];
      setSubjects(subjectData);
      setSubjectId(subjectData?.[0]?._id || "");
      setSelectedSubject(subjectData?.[0] || {});
    } catch (error) {
      responseDialog("error", "Error Alert", "Something went wrong.");
    }
  };

  // function to get all affective domain
  const getAffectiveDomains = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await assessmentApi.getAffectiveDomains(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setAffectiveDomainData([]);
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        setAffectiveDomainData(data);
      }
    } catch (error) {
      responseDialog("error", "Error Alert", `Something went wrong.`);
    } finally {
      setIsLoading(false);
    }
  };

  // function to get all pyschomotor
  const getPsychomotor = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await assessmentApi.getPsychomotor(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setPsychomotor([]);
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        setPsychomotor(data);
      }
    } catch (error) {
      responseDialog("error", "Error Alert", `Something went wrong.`);
    } finally {
      setIsLoading(false);
    }
  };

  // function to get all rating indices
  const getRatingIndices = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await assessmentApi.getRatings(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setRatingIndicesData([]);
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        setRatingIndicesData(data);
      }
    } catch (error) {
      responseDialog("error", "Error Alert", `Something went wrong.`);
    } finally {
      setIsLoading(false);
    }
  };

  // function to get all student
  const getStudents = async (returnData = false) => {
    try {
      if (!tableLoading) setTableLoading(true);
      const page = first / rows;
      let response;
      response = await studentApi.getStudentsInClass(
        page,
        rows,
        search,
        classId,
        "assessment"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setStudentData([]);
      } else {
        if (returnData) {
          return response_data.response;
        } else {
          setStudentData(response_data.response);
          setTotalRecords(
            !empty(response_data.count) ? response_data.count : 0
          );
        }
      }
    } catch (error) {
      responseDialog("error", "Internal Server Error", `Something went wrong.`);
    } finally {
      setTableLoading(false);
    }
  };

  const getClassDetails = async () => {
    try {
      const response = await classApi.getSingleClass(classId);
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        return setClassData({});
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : {};
        const _classCategoryId =
          !empty(data) && !empty(data.categoryId) ? data.categoryId : "";
        const _defaultCategoryId =
          !empty(data) && !empty(data.defaultCategoryId)
            ? data.defaultCategoryId
            : "";
        setClassCategoryId(_classCategoryId);
        setDefaultCategoryId(_defaultCategoryId);
        const scoreGrades =
          !empty(user) && !empty(user.scoreGrades) ? user.scoreGrades : [];
        const reIndexedScoreGrades = !empty(scoreGrades)
          ? reIndex(scoreGrades, "categoryId")
          : {};
        const _remark =
          !empty(reIndexedScoreGrades) &&
          !empty(reIndexedScoreGrades[classCategoryId]) &&
          !empty(reIndexedScoreGrades[classCategoryId].remarks)
            ? reIndexedScoreGrades[classCategoryId].remarks
            : [];
        setRemarks(_remark);
        setScoreGrades(reIndexedScoreGrades);
        setClassData(data);
      }
    } catch (error) {
      responseDialog("error", "Internal Server Error", `Something went wrong.`);
    }
  };

  const getSubjectsInClass = async () => {
    try {
      const response = await classApi.getSubjectsInClass(
        classId,
        1000
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        return setReIndexedSubjects({});
      } else {
        const classSubjects = response_data.response;
        const reIndexedSubjects = reIndex(classSubjects, "_id");
        setReIndexedSubjects(reIndexedSubjects);
      }
    } catch (error) {
      responseDialog("error", "Internal Server", `Something went wrong.`);
    }
  };

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  /**
   * Submit assessment
   * @param {*} values
   */
  const handleSubmit = async (values) => {
    try {
      if (!isActionLoading) setIsActionLoading(true);
      if (empty(values)) {
        return responseDialog(
          "error",
          "Internal Server",
          `There are no values provided`
        );
      }
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const studentId =
        !empty(activeDetails) && !empty(activeDetails._id)
          ? activeDetails._id
          : "";
      const ca1 = !isUndefined(values.ca1) ? values.ca1 : "";
      const ca2 = !isUndefined(values.ca2) ? values.ca2 : "";
      const exam = !isUndefined(values.exam) ? values.exam : "";
      if (ca1 > ca1_max) {
        return responseDialog(
          "error",
          "Validation Error",
          `CA 1 score: ${ca1} exceeds the maximum allowed value: ${ca1_max}`
        );
      }
      if (ca2 > ca2_max) {
        return responseDialog(
          "error",
          "Validation Error",
          `CA 2 score: ${ca2} exceeds the maximum allowed value: ${ca2_max}`
        );
      }
      if (exam > exam_max) {
        return responseDialog(
          "error",
          "Validation Error",
          `Exam score: ${exam} exceeds the maximum allowed value: ${exam_max}`
        );
      }
      const response = await assessmentApi.recordAssessment(
        schoolId,
        studentId,
        ca1,
        ca2,
        exam,
        subjectId,
        classId
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      } else {
        setIsStudentDialog(false);
        await getStudents();
        responseDialog("success", "Success", "Operation successful");
      }
    } catch (error) {
      responseDialog("error", "Internal Server Error", `Something went wrong.`);
    } finally {
      setIsActionLoading(false);
    }
  };

  /**
   * Submit multiple assessments
   * @param {*} values
   */
  const handleMultipleSubmit = async () => {
    try {
      if (!isActionLoading) setIsActionLoading(true);
      if (empty(updatedAssessment)) {
        return responseDialog(
          "error",
          "Internal Server",
          `There are no values entered`
        );
      }
      const studentId =
        !empty(activeDetails) && !empty(activeDetails._id)
          ? activeDetails._id
          : "";
      const response = await assessmentApi.recordAssessments(
        studentId,
        updatedAssessment
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      }

      setOpenMultiAssessmentModal(false);
      getStudents();
      return responseDialog("success", "Success", "Operation successful");
    } catch (error) {
      responseDialog("error", "Internal Server Error", `Something went wrong.`);
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleCommentSubmit = async (values) => {
    try {
      if (!isActionLoading) setIsActionLoading(true);
      if (empty(values)) {
      }
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const studentId =
        !empty(activeDetails) && !empty(activeDetails._id)
          ? activeDetails._id
          : "";
      const comment = !empty(values.comment) ? values.comment : "";
      const response = await assessmentApi.addStudentPerformanceComment(
        schoolId,
        studentId,
        comment
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      } else {
        responseDialog("success", "Success", "Comment added successfully.");
      }
    } catch (error) {
      responseDialog("error", "Internal Server Error", `Something went wrong.`);
    } finally {
      setIsActionLoading(false);
    }
  };

  const handlePsychomotorSubmit = async (values) => {
    try {
      if (!isActionLoading) setIsActionLoading(true);
      if (empty(values)) {
      }

      const validValues = validPayload(values);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const studentId =
        !empty(activeDetails) && !empty(activeDetails._id)
          ? activeDetails._id
          : "";
      const response = await assessmentApi.addPsychomotorForStudent(
        schoolId,
        studentId,
        sessionId,
        termId,
        validValues
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      } else {
        responseDialog(
          "success",
          "Success",
          "Psychomotor updated successfully."
        );
      }
    } catch (error) {
      responseDialog("error", "Internal Server Error", `Something went wrong.`);
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleAffectiveDomainSubmit = async (values) => {
    try {
      if (!isActionLoading) setIsActionLoading(true);
      if (empty(values)) {
      }

      const validValues = validPayload(values);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const studentId =
        !empty(activeDetails) && !empty(activeDetails._id)
          ? activeDetails._id
          : "";
      const response = await assessmentApi.addAffectiveDomainForStudent(
        schoolId,
        studentId,
        sessionId,
        termId,
        validValues
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.success) ||
        !response_data.success
      ) {
        responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      } else {
        responseDialog(
          "success",
          "Success",
          "Psychomotor updated successfully."
        );
      }
    } catch (error) {
      responseDialog("error", "Internal Server Error", `Something went wrong.`);
    } finally {
      setIsActionLoading(false);
    }
  };

  /**
   * Get student assessemnt
   * @param {*} data
   * @returns
   */
  const getStudentAssessment = (data) => {
    try {
      const studentAssessmentData =
        !empty(data) && !empty(data.assessment) ? data.assessment : [];
      let count = 0;
      let assessmentSum = 0;
      let currentStudentAssessmentData = studentAssessmentData.filter(
        // eslint-disable-next-line array-callback-return
        (item) => {
          if (!empty(item) && isObject(item)) {
            item._id = count;
            const ca1 = !empty(item.ca1) && parseInt(item.ca1) ? item.ca1 : 0;
            const ca2 = !empty(item.ca2) && parseInt(item.ca2) ? item.ca2 : 0;
            const exam =
              !empty(item.exam) && parseInt(item.exam) ? item.exam : 0;
            const total = parseInt(ca1) + parseInt(ca2) + parseInt(exam);

            const itemSessionId =
              !empty(item) && !empty(item.sessionId) ? item.sessionId : "";
            const itemTermId =
              !empty(item) && !empty(item.termId) ? item.termId : "";
            const subjectId =
              !empty(item) && !empty(item.subjectId) ? item.subjectId : "";
            if (
              itemSessionId === sessionId &&
              itemTermId === termId &&
              !empty(reIndexedSubjects[subjectId])
            ) {
              assessmentSum += total;
            }
            count++;
            return (
              itemSessionId === sessionId &&
              itemTermId === termId &&
              !empty(reIndexedSubjects[subjectId])
            );
          }
        }
      );

      currentStudentAssessmentData =
        !empty(currentStudentAssessmentData) &&
        isArray(currentStudentAssessmentData)
          ? currentStudentAssessmentData
          : [];
      return { currentStudentAssessmentData, assessmentSum };
    } catch (error) {
      return { currentStudentAssessmentData: [], assessmentSum: 0 };
    }
  };

  /**
   * Get assessment data
   * @param {*} data
   */
  const assessmentData = async (data) => {
    try {
      const studentReport =
        !empty(data) && !empty(data.reports) ? data.reports : [];
      const _getStudentAssessment = getStudentAssessment(data);
      const currentStudentAssessmentData =
        _getStudentAssessment?.currentStudentAssessmentData || [];
      setSelectedStudentTotal(_getStudentAssessment?.assessmentSum || 0);
      setStudentAssessment(currentStudentAssessmentData);

      const reIndexedAssessment = reIndex(
        currentStudentAssessmentData,
        "subjectId"
      );
      const currentSubject =
        !empty(reIndexedAssessment) && !empty(reIndexedAssessment[subjectId])
          ? reIndexedAssessment[subjectId]
          : {};
      const ca1 =
        !empty(currentSubject) && !empty(currentSubject.ca1)
          ? currentSubject.ca1
          : 0;
      const ca2 =
        !empty(currentSubject) && !empty(currentSubject.ca2)
          ? currentSubject.ca2
          : 0;
      const exam =
        !empty(currentSubject) && !empty(currentSubject.exam)
          ? currentSubject.exam
          : 0;

      setInitialValues({
        ca1,
        ca2,
        exam,
      });

      let comment = "";
      let studentPsychomotor = {};
      let affectiveDomain = {};
      for (let i = 0; i < studentReport.length; i++) {
        const itemSessionId =
          !empty(studentReport[i]) && !empty(studentReport[i].sessionId)
            ? studentReport[i].sessionId
            : "";
        const itemTermId =
          !empty(studentReport[i]) && studentReport[i].termId
            ? studentReport[i].termId
            : "";
        if (itemSessionId === sessionId && itemTermId === termId) {
          comment =
            !empty(studentReport[i]) && !empty(studentReport[i].comment)
              ? studentReport[i].comment
              : "";

          studentPsychomotor =
            !empty(studentReport[i]) && !empty(studentReport[i].psychomotor)
              ? studentReport[i].psychomotor
              : {};
          affectiveDomain =
            !empty(studentReport[i]) && !empty(studentReport[i].affectiveDomain)
              ? studentReport[i].affectiveDomain
              : {};
          break;
        }
      }

      const firstName = !empty(data.firstName) ? data.firstName : "";
      const lastName = !empty(data.lastName) ? data.lastName : "";
      const fullName = `${lastName} ${firstName}`;
      data.fullName = fullName;
      setStudentReportComment(comment);
      setStudentPsychomotor(studentPsychomotor);
      setStudentAffectiveDomain(affectiveDomain);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  //function to hide school edit modal
  const closeAssessmentDialog = () => {
    setIsStudentDialog(false);
  };

  // function to hide multiple assessment modal
  const closeMultiAssessmentDialog = () => {
    setOpenMultiAssessmentModal(false);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const onSearchChange = (event) => {
    setSearch(event.target.value);
    setFirst(0);
  };

  const subjectTemplate = (data) => {
    const assessmentSubjectId =
      !empty(data) && !empty(data.subjectId) ? data.subjectId : "";
    const subjectTitle =
      !empty(reIndexedSubjects) &&
      !empty(reIndexedSubjects[assessmentSubjectId]) &&
      !empty(reIndexedSubjects[assessmentSubjectId].title)
        ? reIndexedSubjects[assessmentSubjectId].title
        : "";

    return subjectTitle;
  };

  const ca1Template = (data) => {
    const ca1 = !empty(data) && !empty(data.ca1) ? data.ca1 : 0;
    return ca1;
  };

  const ca2Template = (data) => {
    const ca2 = !empty(data) && !empty(data.ca2) ? data.ca2 : 0;
    return ca2;
  };

  const examTemplate = (data) => {
    const exam = !empty(data) && !empty(data.exam) ? data.exam : 0;
    return exam;
  };

  const totalTemplate = (ca1, ca2, examScore) => {
    const total = parseInt(ca1) + parseInt(ca2) + parseInt(examScore);

    let score_tag = "";
    if (total >= 70) {
      score_tag = "green";
    } else if (total >= 60 && total <= 69.9) {
      score_tag = "#633ccd";
    } else if (total >= 50 && total <= 59.9) {
      score_tag = "orange";
    } else if (total >= 45 && total <= 49.9) {
      score_tag = "gray";
    } else {
      score_tag = "red";
    }

    return <span style={{ color: score_tag }}>{total}</span>;
  };

  const gradeTemplate = (ca1, ca2, exam) => {
    const total = parseInt(ca1) + parseInt(ca2) + parseInt(exam);

    const getGrade = findGrade(remarks, scoreGrades, defaultCategoryId, total);
    const grade =
      !empty(getGrade) && !empty(getGrade.grade) ? getGrade.grade : "";

    return grade;
  };

  const remarkTemplate = (ca1, ca2, exam) => {
    const total = parseInt(ca1) + parseInt(ca2) + parseInt(exam);

    const getGrade = findGrade(remarks, scoreGrades, defaultCategoryId, total);
    const remark =
      !empty(getGrade) && !empty(getGrade.remark) ? getGrade.remark : "";

    return remark;
  };

  // hide activation modal
  const hideActivationModal = () => {
    setActivationModalOpen(false);
  };

  //function to activate student on payment
  const activateStudent = async () => {
    try {
      if (activationModalOpen) setActivationModalOpen(false);
      if (!isActionLoading) setIsActionLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const studentId =
        !empty(activeDetails) && !empty(activeDetails._id)
          ? activeDetails._id
          : "";
      const response = await studentApi.activateStudent([studentId], schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : `Failed to activate student`;
        return responseDialog("error", "Error Alert", error_response);
      }

      const students = await getStudents(true);
      const reIndexedStudents = !empty(students)
        ? reIndex(students, "_id")
        : {};
      let currentStudent =
        !empty(reIndexedStudents) && !empty(reIndexedStudents[studentId])
          ? reIndexedStudents[studentId]
          : {};
      openAssessmentModal(currentStudent, false);
      return responseDialog(
        "success",
        "Success",
        `Activated student successfully!`
      );
    } catch (error) {
      return responseDialog(
        "error",
        "Something went wrong",
        "Request failed please try again later"
      );
    } finally {
      setIsActionLoading(false);
    }
  };

  const activateStudentDialogFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideActivationModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={() => {
          activateStudent();
        }}
      />
    </div>
  );

  const getSelectedSubject = (data, index) => {
    setSelectedSubject(data);
    setActiveIndex(index);
    setSubjectId(() => data?._id || "");
  };

  // handle input type
  const handleInputType =
    (name, setFieldValue, assessmentType, index) => async (e) => {
      const value =
        !empty(e) &&
        !empty(e.target) &&
        !empty(e.target.value) &&
        isString(e.target.value)
          ? e.target.value
          : "";

      setFieldValue(name, value);
      const _updatedAssessment = isArray(updatedAssessment)
        ? updatedAssessment
        : [];
      if (isObject(_updatedAssessment[index])) {
        _updatedAssessment[index][assessmentType] = parseFloat(value);
        setUpdatedAssessment(_updatedAssessment);
      }
    };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              title="Record Assessments"
              children={
                <>
                  <span style={{ marginRight: 30 }}>
                    Session: <strong>{currentSessionTitle}</strong>
                  </span>
                  <span style={{ marginRight: 30 }}>
                    Term: <strong>{currentTermTitle}</strong>
                  </span>
                  <span style={{ marginRight: 30 }}>
                    Class:{" "}
                    <strong>
                      {!empty(classData) && !empty(classData.title)
                        ? classData.title
                        : ""}
                    </strong>
                  </span>

                  <span>
                    Subject: <strong>{selectedSubject?.title || ""}</strong>
                  </span>
                </>
              }
            />
            {/* end of header */}

            <div className="flex row-g-12 col-g-12 flex-wrap mb-20 mt-40">
              {isArray(subjects) &&
                subjects.map((data, index) => {
                  return (
                    <div
                      key={data?._id}
                      className="subject-assessment-box"
                      style={{
                        color:
                          activeIndex === index ? colors.white : colors.black,
                        backgroundColor:
                          activeIndex === index ? colors.primary : colors.white,
                      }}
                      onClick={() => getSelectedSubject(data, index)}
                    >
                      {data?.title}
                    </div>
                  );
                })}
            </div>
            {/* table start */}
            {!tableLoading ? (
              <StudentsTable
                students={studentData}
                openAssessmentModal={openAssessmentModal}
                openMultipleAssessmentModal={openMultipleAssessmentModal}
                onPageChange={onPageChange}
                loading={isLoading}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={search}
                onSearchChange={onSearchChange}
                assessment={true}
                recordScores={true}
                academicData={{ sessionId, termId }}
              />
            ) : (
              <TableLoading rows={7} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </AppWrapper>

      {/* Open general assessment modal */}
      <Dialog
        visible={isStudentDialog}
        style={{ width: "70rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header={`Record Assessment`}
        modal
        className="p-fluid"
        onHide={closeAssessmentDialog}
      >
        <>
          <p>
            <span style={{ marginRight: 40 }}>
              Student Name:
              <NavLink
                to={`/student/${
                  !empty(activeDetails) && !empty(activeDetails._id)
                    ? " " + activeDetails._id
                    : ""
                }/profile`}
                style={{ textDecoration: "none", color: colors.primary }}
              >
                <strong>
                  {!empty(activeDetails) && !empty(activeDetails.fullName)
                    ? " " + activeDetails.fullName
                    : ""}
                </strong>
              </NavLink>
            </span>
            <span style={{ marginRight: 40 }}>
              Subject: <strong>{selectedSubject?.title || ""}</strong>
            </span>
            <span>
              Class:
              <strong>
                {!empty(classData) && !empty(classData.title)
                  ? " " + classData.title
                  : ""}
              </strong>
            </span>
          </p>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form
              style={{
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: 8,
                }}
              >
                <InputField
                  placeholder="Enter CA1 Score"
                  name="ca1"
                  height={50}
                  type="number"
                  labelTitle="CA1"
                />
                <InputField
                  placeholder="Enter CA2 Score"
                  name="ca2"
                  height={50}
                  type="number"
                  labelTitle="CA2"
                />
                <InputField
                  placeholder="Enter Exam Score"
                  name="exam"
                  height={50}
                  type="number"
                  labelTitle="Exam"
                />
              </div>
              <ButtonIcon
                height={45}
                marginTop={2}
                color="#ffffff"
                backgroundColor="#633ccd"
                width={120}
                borderColor="#633ccd"
                buttonText="Update"
                type="submit"
              />
            </Form>
          </Formik>
          {hasPaid ? (
            <>
              <div>
                <div style={{ marginTop: 50, marginBottom: 20 }}>
                  <strong style={{ fontSize: 20 }}>Recorded Assessments</strong>
                  <p style={{ marginTop: 10, fontSize: 14, color: "red" }}>
                    <em>
                      <strong>Note: </strong>For current{" "}
                      <strong>Session</strong> and <strong>Term</strong>
                    </em>
                  </p>
                </div>
                {
                  <DataTable
                    value={studentAssessment}
                    tableStyle={{ minWidth: "30rem" }}
                    dataKey="_id"
                    stateKey="dt-state-demo-local"
                  >
                    <Column
                      field="subjects"
                      header="Subjects"
                      body={subjectTemplate}
                    ></Column>
                    <Column
                      field="ca1"
                      header="CA1"
                      body={ca1Template}
                    ></Column>
                    <Column
                      field="ca2"
                      header="CA2"
                      body={ca2Template}
                    ></Column>
                    <Column
                      field="exam"
                      header="Exam"
                      body={examTemplate}
                    ></Column>
                    <Column
                      field="total"
                      header="Total"
                      body={(rowData) => {
                        const examScore = examTemplate(rowData);
                        const ca1 = ca1Template(rowData);
                        const ca2 = ca2Template(rowData);
                        return totalTemplate(ca1, ca2, examScore);
                      }}
                    ></Column>
                    <Column
                      field="grade"
                      header="Grade"
                      body={(rowData) => {
                        const examScore = examTemplate(rowData);
                        const ca1 = ca1Template(rowData);
                        const ca2 = ca2Template(rowData);
                        return gradeTemplate(ca1, ca2, examScore);
                      }}
                    ></Column>
                    <Column
                      field="remark"
                      header="Remark"
                      body={(rowData) => {
                        const examScore = examTemplate(rowData);
                        const ca1 = ca1Template(rowData);
                        const ca2 = ca2Template(rowData);
                        return remarkTemplate(ca1, ca2, examScore);
                      }}
                    ></Column>
                  </DataTable>
                }
                <div className="mt-20 flex assessment_summary">
                  <span className="mr-60">
                    <strong>No. of Subjects: </strong>
                    {studentAssessment.length}
                  </span>
                  <span className="mr-60">
                    <strong>Total: </strong>
                    {selectedStudentTotal}
                  </span>
                  <span>
                    <strong>Average: </strong>
                    {isNaN(selectedStudentTotal) ||
                    studentAssessment?.length <= 0
                      ? 0
                      : (
                          selectedStudentTotal / studentAssessment?.length
                        ).toFixed(1)}
                    %
                  </span>
                </div>
                <div className="psychomoto_form_box">
                  {!empty(affectiveDomainData) &&
                  isArray(affectiveDomainData) ? (
                    <div>
                      <div style={{ marginTop: 50, marginBottom: 10 }}>
                        <strong style={{ fontSize: 16 }}>
                          Student's Affective Domain
                        </strong>
                      </div>
                      <div className="affective-domain">
                        <Formik
                          initialValues={{
                            ...affectiveDomainData.reduce((acc, item) => {
                              const title =
                                !empty(item) && !empty(item.title)
                                  ? item.title
                                  : "";
                              const snakeCaseTitle = convertToSnakeCase(title);

                              // Check if studentAffectiveDomain has a corresponding value
                              acc[snakeCaseTitle] =
                                studentAffectiveDomain[snakeCaseTitle] || "";
                              return acc;
                            }, {}),
                          }}
                          onSubmit={handleAffectiveDomainSubmit}
                        >
                          {({ values, handleChange }) => (
                            <Form
                              style={{
                                maxWidth: "100%",
                              }}
                            >
                              <div className="asseessment_box">
                                <Stepper
                                  ref={stepperRef}
                                  style={{ flexBasis: "50rem" }}
                                  orientation="vertical"
                                >
                                  {affectiveDomainData.map((item, index) => {
                                    const title =
                                      !empty(item) && !empty(item.title)
                                        ? capitalize(item.title)
                                        : "";
                                    const fieldName = convertToSnakeCase(title);
                                    return (
                                      <StepperPanel header={title} key={index}>
                                        <div
                                          className="flex flex-column"
                                          key={index}
                                        >
                                          <SelectField
                                            index={index}
                                            placeholder={`Rate student's ${title}`}
                                            name={fieldName}
                                            options={ratingIndicesData}
                                            height={50}
                                            width={200}
                                            display="value"
                                            valueKey="value"
                                            display1="description"
                                            selectedOption={values[fieldName]}
                                            handleChangeFunc={handleChange}
                                          />
                                        </div>
                                      </StepperPanel>
                                    );
                                  })}
                                </Stepper>
                              </div>
                              <ButtonIcon
                                height={45}
                                marginTop={2}
                                color={colors.white}
                                backgroundColor={colors.primary}
                                width={120}
                                borderColor={colors.primary}
                                buttonText="Update"
                                type="submit"
                              />
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  ) : null}
                  {!empty(psychomotor) && isArray(psychomotor) ? (
                    <div>
                      <div style={{ marginTop: 50, marginBottom: 10 }}>
                        <strong style={{ fontSize: 18 }}>
                          Student's Psychomotor
                        </strong>
                      </div>
                      <div className="psychomotor">
                        <Formik
                          initialValues={{
                            ...psychomotor.reduce((acc, item) => {
                              const title =
                                !empty(item) && !empty(item.title)
                                  ? item.title
                                  : "";
                              const snakeCaseTitle = convertToSnakeCase(title);

                              // Check if userPsychomotor has a corresponding value
                              acc[snakeCaseTitle] =
                                studentPsychomotor[snakeCaseTitle] || "";
                              return acc;
                            }, {}),
                          }}
                          onSubmit={handlePsychomotorSubmit}
                        >
                          {({ values, handleChange }) => (
                            <Form
                              style={{
                                maxWidth: "100%",
                              }}
                            >
                              <div className="asseessment_box">
                                <Stepper
                                  ref={stepperRef}
                                  orientation="vertical"
                                >
                                  {psychomotor.map((item, index) => {
                                    const title =
                                      !empty(item) && !empty(item.title)
                                        ? capitalize(item.title)
                                        : "";
                                    const fieldName = convertToSnakeCase(title);
                                    return (
                                      <StepperPanel header={title} key={index}>
                                        <div className="flex">
                                          <SelectField
                                            key={index}
                                            index={index}
                                            labelTitle={title}
                                            placeholder={`Rate student's ${title}`}
                                            name={fieldName}
                                            options={ratingIndicesData}
                                            height={50}
                                            width={200}
                                            display="value"
                                            valueKey="value"
                                            display1="description"
                                            selectedOption={values[fieldName]}
                                            handleChangeFunc={handleChange}
                                          />
                                        </div>
                                      </StepperPanel>
                                    );
                                  })}
                                </Stepper>
                              </div>
                              <ButtonIcon
                                height={45}
                                marginTop={2}
                                color={colors.white}
                                backgroundColor={colors.primary}
                                width={120}
                                borderColor={colors.primary}
                                buttonText="Update"
                                type="submit"
                              />
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div style={{ marginTop: 70, marginBottom: 10 }}>
                  <strong style={{ fontSize: 18 }}>
                    Class Teacher's Comment
                  </strong>
                  <br />
                  <strong>
                    {currentSessionTitle} - {currentTermTitle}
                  </strong>
                  <p style={{ marginTop: 10, fontSize: 14, color: "red" }}>
                    <em>
                      <strong>Note: </strong>Enter comment for student's overall
                      performance
                    </em>
                  </p>
                </div>
                <Formik
                  initialValues={{ comment: studentReportComment }}
                  validationSchema={validationCommentSchema}
                  onSubmit={handleCommentSubmit}
                >
                  <Form
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        columnGap: 8,
                      }}
                    >
                      <InputField
                        placeholder="Enter comment for student performance"
                        name="comment"
                        height={150}
                        labelTitle="Comment"
                        as="textarea"
                        rows={8}
                        cols={10}
                      />
                    </div>
                    <ButtonIcon
                      height={45}
                      marginTop={2}
                      color={colors.white}
                      backgroundColor={colors.primary}
                      width={120}
                      borderColor={colors.primary}
                      buttonText="Update"
                      type="submit"
                    />
                  </Form>
                </Formik>
              </div>
            </>
          ) : (
            <div className="mt-50 assessment_not_paid">
              <FaExclamationTriangle color="red" size={25} />
              <p className="mt-10 fs-18 mb-5">
                <strong>Recorded Assessment Unavailable</strong>
              </p>
              <p>This student has an outstanding portal levy</p>
              {/* <div>
                <ButtonIcon
                  height={45}
                  color={colors.primary}
                  backgroundColor="transparent"
                  width={220}
                  fontWeight="bold"
                  borderColor="transparent"
                  buttonText="Activate Student"
                  onClick={() => setActivationModalOpen(true)}
                />
              </div> */}
            </div>
          )}
        </>
      </Dialog>

      {/* Open multi subject assessment upload modal */}
      <Dialog
        visible={openMultiAssessmentModal}
        style={{ width: "70rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header={`Record Assessments`}
        modal
        className="p-fluid"
        onHide={closeMultiAssessmentDialog}
      >
        <div style={{ padding: "20px 5%" }}>
          <p>
            <span style={{ marginRight: 40 }}>
              Student Name:
              <NavLink
                to={`/student/${
                  !empty(activeDetails) && !empty(activeDetails._id)
                    ? " " + activeDetails._id
                    : ""
                }/profile`}
                style={{ textDecoration: "none", color: colors.primary }}
              >
                <strong>
                  {!empty(activeDetails) && !empty(activeDetails.fullName)
                    ? " " + activeDetails.fullName
                    : ""}
                </strong>
              </NavLink>
            </span>
            <span>
              Class:
              <strong>
                {!empty(classData) && !empty(classData.title)
                  ? " " + classData.title
                  : ""}
              </strong>
            </span>
          </p>
          <Formik
            initialValues={multiInitialValues}
            validationSchema={validationMultiSchema}
            onSubmit={handleMultipleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form
                style={{
                  width: "100%",
                }}
              >
                {Array.isArray(subjects) &&
                  subjects.map((subject, index) => {
                    const subjectId = subject?._id || index;

                    return (
                      <div className="mb-30" key={subjectId}>
                        <div
                          style={{
                            color: colors.mainSecondary,
                            fontWeight: "bold",
                            marginBottom: 10,
                          }}
                        >
                          {subject?.title || "--"}:
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            columnGap: 8,
                          }}
                        >
                          <InputFieldChange
                            placeholder="Enter CA1 Score"
                            name={`recordedAssessments[${index}].ca1`}
                            height={50}
                            type="number"
                            labelTitle="CA1"
                            value={
                              values.recordedAssessments?.[index]?.ca1 || ""
                            }
                            onChange={handleInputType(
                              `recordedAssessments[${index}].ca1`,
                              setFieldValue,
                              "ca1",
                              index
                            )}
                          />
                          <InputFieldChange
                            placeholder="Enter CA2 Score"
                            name={`recordedAssessments[${index}].ca2`}
                            height={50}
                            type="number"
                            labelTitle="CA2"
                            value={
                              values.recordedAssessments?.[index]?.ca2 || ""
                            }
                            onChange={handleInputType(
                              `recordedAssessments[${index}].ca2`,
                              setFieldValue,
                              "ca2",
                              index
                            )}
                          />
                          <InputFieldChange
                            placeholder="Enter Exam Score"
                            name={`recordedAssessments[${index}].exam`}
                            height={50}
                            type="number"
                            labelTitle="Exam"
                            value={
                              values.recordedAssessments?.[index]?.exam || ""
                            }
                            onChange={handleInputType(
                              `recordedAssessments[${index}].exam`,
                              setFieldValue,
                              "exam",
                              index
                            )}
                          />
                        </div>
                      </div>
                    );
                  })}

                <ButtonIcon
                  height={45}
                  marginTop={2}
                  color="#ffffff"
                  backgroundColor="#633ccd"
                  width={120}
                  borderColor="#633ccd"
                  buttonText="Update"
                  type="submit"
                />
              </Form>
            )}
          </Formik>
        </div>
      </Dialog>

      <Dialog
        visible={activationModalOpen}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={activateStudentDialogFooter}
        onHide={hideActivationModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <>
              <p>
                Are you sure you want to <strong>activate</strong> this student?{" "}
                <br />
                <br />
                By clicking "Yes", you are confirming that{" "}
                <strong>
                  {!empty(activeDetails) && !empty(activeDetails.fullName)
                    ? activeDetails.fullName
                    : ""}
                </strong>{" "}
                made portal payment for this term.
                <br />
                <br />
                <em style={{ color: colors.danger }}>
                  <strong>Note:</strong> This action cannot be undone.
                </em>
              </p>
            </>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default RecordAssessment;
